/* eslint-disable max-len */
import { isPlatformServer } from '@angular/common';
import { Injector, PLATFORM_ID } from '@angular/core';
import { environment, OCC_ENDPOINTS } from '@core/const';
import { OccConfig, OccEndpoints, ProductScope } from '@spartacus/core';

export type CustomOccConfig = OccConfig & {
  backend: {
    occ: {
      endpoints: OccEndpoints | Record<keyof typeof OCC_ENDPOINTS, string>;
    };
  };
};

/* TODO: Temporary workaround (see Spartacus GitHub #5886) */
export function occConfigFactory(injector: Injector): CustomOccConfig {
  const platformId = injector.get(PLATFORM_ID);

  const config: CustomOccConfig = {
    backend: {
      occ: {
        prefix: '/occ/v2/',
        endpoints: {
          product: {
            details:
              'products/${productCode}?fields=dealType,name,slug,averageRating,badges(DEFAULT),stock(DEFAULT),unitPrices(FULL),description,seo(FULL),availableForPickup,code,unit,multiunit,url,price(FULL),crossedPrice(FULL),transitPrice(FULL),personalPrice(FULL),transitUnit(FULL),numberOfReviews,manufacturer,categories(FULL),categoryNamesForAnalytics,priceRange,multidimensional,configuratorType,configurable,tags,images(FULL),marketingAttributes,certificates,isArchive,services',
            list: 'products/${productCode}?fields=dealType,code,slug,name,unit,unitPrices(FULL),availableInStores(FULL),badges(DEFAULT),multiunit,price(FULL),crossedPrice(FULL),transitPrice(FULL),personalPrice(FULL),categories(FULL),categoryNamesForAnalytics,images(DEFAULT),stock(FULL),isArchive,classifications',
          },
          productSearch:
            'products/search?fields=searchEngineStrategy,algorithmsForAddingRelatedProducts,categoryCode,products(code,bonus,slug,dealType,name,unit,units(FULL),unitPrices(FULL),availableInStores(FULL),badges(DEFAULT),multiunit,price(FULL),crossedPrice(FULL),transitPrice(FULL),personalPrice(FULL),images(DEFAULT),stock(FULL),marketingAttributes,isArchive,categories(FULL),categoryNamesForAnalytics),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),banners(FULL),freeTextSearch,currentQuery,keywordRedirectUrl',
          stores:
            'stores?fields=stores(name,displayName,pickupDate,openingHours(weekDayOpeningList(FULL),specialDayOpeningList(FULL)),geoPoint(latitude,longitude),address(streetname,streetnumber), features),pagination(DEFAULT),sorts(DEFAULT)',
          baseSitesForConfig:
            'basesites?fields=DEFAULT,baseSites(defaultPreviewCatalogId,defaultPreviewArticleCode,defaultPreviewCategoryCode,defaultPreviewProductCode,urlEncodingAttributes,urlPatterns,name,stores(FULL))',
          baseSites:
            'basesites?fields=DEFAULT,baseSites(defaultPreviewCatalogId,defaultPreviewArticleCode,defaultPreviewCategoryCode,defaultPreviewProductCode,urlEncodingAttributes,urlPatterns,name,stores(FULL))',
          environment: OCC_ENDPOINTS.environment,
        },
        useWithCredentials: true,
      },
      loadingScopes: {
        product: {
          details: {
            include: [ProductScope.DETAILS],
          },
        },
      },
      media: {},
    },
  };

  config.backend.occ.baseUrl = isPlatformServer(platformId) ? environment.apiBaseUrlSsr : environment.apiBaseUrlCsr;

  return config;
}
